module.exports = __webpack_public_path__ + "static/joyful_0-be1488b199b6b9ddb424966cea96f4b4.png";